import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';

import playbookEditEntryPoint from '@jira/spa-apps__project-settings-playbooks-edit-view/src/playbookEditViewEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskPlaybooksEditRoute } from '@jira/router-routes__project-settings-playbooks-routes/src/servicedeskPlaybooksEditRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { PlaybookEditSkeleton } from '@jira/playbooks__edit-screen/src/PlaybookEditSkeleton.tsx';
import { RedirectToPlaybookEditPage } from './RedirectToPlaybookEditPage.tsx';
import type { Route } from '@atlassian/react-resource-router';

const editEntryPoint = createPageEntryPoint({
	main: playbookEditEntryPoint,
});

export const servicedeskPlaybooksEditRouteEntry: Route = createEntry(
	servicedeskPlaybooksEditRoute,
	() => ({
		group: 'project-settings-servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		entryPoint() {
			if (
				fg('aem_rr_playbooks')
					? !isFeatureEnabled('jira-service-management', 'jsm-automation-playbook')
					: isFedRamp()
			) {
				return notFoundPageEntrypoint;
			}
			if (fg('playbooks_edit_route_migration')) {
				return undefined;
			}
			return editEntryPoint;
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],

		meta: {
			reporting: {
				id: 'project-settings.playbooks.admin-edit-view',
				packageName: camelCase('project-settings-playbooks-edit'),
				teamName: 'ITOps Phantom',
			},
		},

		// eslint-disable-next-line no-restricted-syntax
		component: fg('playbooks_edit_route_migration')
			? RedirectToPlaybookEditPage
			: ErrorPagesNotFound,
		isRedirect: fg('playbooks_edit_route_migration'),
		ufoName: 'playbook-edit',
		skeleton: PlaybookEditSkeleton,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
